import React from 'react';
import { Container, Row, Col, Image, ListGroup } from 'react-bootstrap';
import Blog1 from '../Components/img/Blog1.jpg'; // Using the image from the blog

const MentalHealth = () => {
  return (
    <Container className="py-5">
      <Row className="align-items-center">
        <Col md={6}>
        <h2 className="text-dark">The Importance of Mental Health</h2>
          <p className="text-muted">
            Mental health plays a vital role in overall well-being. It impacts how we think, feel, 
            and act in our daily lives. Prioritizing **mental wellness** helps in **stress management**, 
            enhances emotional resilience.
          </p>
          <p className="text-muted">
            A healthy mind fosters **positive relationships**, better decision-making, and a sense of fulfillment. 
            Ignoring mental health can lead to **str`ess, anxiety, and depression**, affecting both personal and professional life.
          </p>
          <Image src={Blog1} alt="Mental Health Awareness" fluid className="rounded shadow" />
        </Col>
        <Col md={6}>
         

          <h5 className="text-dark mt-4 "> Tips for Better Mental Health:</h5>
          <ListGroup variant="flush" className="mt-3">
            <ListGroup.Item>✅ <strong>Practice Mindfulness & Meditation:</strong> Helps reduce stress and anxiety.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Stay Physically Active:</strong> Exercise boosts mood and mental clarity.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Build Healthy Relationships:</strong> Social connections improve emotional well-being.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Ensure Adequate Sleep:</strong> Rest is crucial for cognitive function and emotional balance.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Seek Professional Help:</strong> Therapy and counseling provide valuable support.</ListGroup.Item>
          </ListGroup>

          <p className="text-muted mt-3">
            Stay informed with expert advice and strategies for enhancing your **mental wellness**. 
            Explore more about **self-care routines, stress-relief techniques,** and **mental health awareness**.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default MentalHealth;
